import React, { useContext, useState } from 'react'
import classNames from 'classnames'

import TmoButton from '../tmoButtons/TmoButton'
import ModalV2 from './ModalV2'
import ModalContext from '../context/ModalContext'
import TmoInput from '../tmoForms/TmoInput'
import LabelWithInput from '../tmoForms/LabelWithInput'

import style from './ConfirmationModalV2.module.css'

const ConfirmationModalV2 = ({
  title,
  message,
  acceptButtonText = 'Accept',
  denyButtonText = 'Cancel',
  confirmInput = false,
  type = 'primary',
  usePortal,
  modalType,
  testId,
  confirmText = 'delete'
}) => {
  const { closeModal } = useContext(ModalContext)
  const [confirmationString, setConfirmationString] = useState()

  const handleAcceptClick = () => {
    closeModal({ isConfirmed: true })
  }

  return (
    <ModalV2 type={type} title={title} portal={usePortal} modalType={modalType}>
      <div
        className={classNames(modalType === 'delete' && style.delete)}
        data-testid={testId}
      >
        {message}
        {confirmInput && (
          <div className={style.confirm} data-testid={'confirmInput'}>
            <LabelWithInput
              className={style.confirm_input}
              labelClassName={style.label}
              inputType='primary'
              placeholder='Type here...'
              labelText={
                <React.Fragment>
                  Type{' '}
                  <strong>
                    {modalType === 'delete'
                      ? confirmText.toUpperCase()
                      : acceptButtonText.toUpperCase()}
                  </strong>{' '}
                  to confirm
                </React.Fragment>
              }
              formComponent={TmoInput}
              value={confirmationString}
              onChange={setConfirmationString}
            />
          </div>
        )}
        <div className={style.button_container}>
          <TmoButton
            onClick={closeModal}
            type='secondary'
            className={style.cancel}
            testId={'denyBtn'}
          >
            {denyButtonText}
          </TmoButton>
          <TmoButton
            disabled={
              (modalType === 'delete'
                ? confirmText.toUpperCase()
                : acceptButtonText.toUpperCase()) !== confirmationString
            }
            onClick={handleAcceptClick}
            type='magenta_primary'
            className={style.delete_button}
            testId={'acceptBtn'}
          >
            {acceptButtonText}
          </TmoButton>
        </div>
      </div>
    </ModalV2>
  )
}

export default ConfirmationModalV2
